import { useEffect, useRef, useState } from 'react';
import { EvalApiService } from '../services/EvalApiService';
import { ACTIVE_RUN_STATUSES, EvalRun, isRunTimedOut, RunProgress } from '../types';

export function useRunProgress(runId: string, token: string) {
  const [run, setRun] = useState<EvalRun | null>(null);
  const [progress, setProgress] = useState<RunProgress | null>(null);
  const runRef = useRef<EvalRun | null>(null);
  const timedOutCalledRef = useRef(false);

  useEffect(() => {
    if (!runId) return;

    let active = true;

    const poll = async () => {
      const fetched = await EvalApiService.getRun(token, runId);
      if (!active || !fetched) return;

      if (isRunTimedOut(fetched) && !timedOutCalledRef.current) {
        timedOutCalledRef.current = true;
        const updated = await EvalApiService.timeoutRun(token, runId);
        if (active) setRun(updated);
        return;
      }

      runRef.current = fetched;
      setRun(fetched);

      if (ACTIVE_RUN_STATUSES.has(fetched.status)) {
        const { progress: runProgress } = await EvalApiService.getRunProgress(token, runId);
        if (active) setProgress(runProgress);
      }
    };

    poll();

    const id = setInterval(() => {
      if (!runRef.current || ACTIVE_RUN_STATUSES.has(runRef.current.status)) {
        poll();
      }
    }, 30000);

    return () => {
      active = false;
      clearInterval(id);
    };
  }, [runId, token]); // eslint-disable-line react-hooks/exhaustive-deps

  return { run, progress };
}
